import React from 'react';
import { Search } from '@mui/icons-material';
import styled from 'styled-components';
import { TextField, IconButton } from '../';

export type SearchFieldProps = {
  placeholder?: string;
  content: string;
  handleContentChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSearch: (search: string) => void;
  disabled?: boolean;
};

export const SearchField: React.FunctionComponent<SearchFieldProps> = (
  props: SearchFieldProps,
) => {
  const { placeholder, content, handleContentChange, handleSearch, disabled } =
    props;

  return (
    <Container>
      <TextField
        placeholder={placeholder}
        variant="outlined"
        value={content}
        onChange={handleContentChange}
      />

      <IconButton
        disabled={disabled}
        icon={<Search />}
        sx={{
          height: '3rem',
          width: '3rem',
          backgroundColor: '#951D1D',
          color: 'white',
          borderRadius: '0 5px 5px 0',
          ':hover': {
            backgroundColor: '#951D1D',
          },
          ':disabled': {
            backgroundColor: '#F0F0F0',
          },
        }}
        onClick={() => {
          handleSearch(content);
        }}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;

  .MuiFormControl-root {
    background-color: #fff;
    height: 3rem;
  }

  .MuiInputBase-root {
    border-radius: 5px 0 0 5px;
    height: 3rem;
    input {
      padding: 0 0 0 1rem;
      background-color: #fff;
    }
  }

  .MuiTouchRipple-root {
    display: none;
  }
`;
